import React from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";

import EditSectionScreen from "./EditSectionScreen";
import { reducer, INITIAL_STATE } from "../../../redux/screens/admin/book/AddSectionRedux";
import AuthorizedScreen from "../../../components/base/AuthorizedScreen";
import UIDs from "../../../UIDs";

const uid = UIDs.screens.admin.book.addsection;

class AddSectionScreen extends AuthorizedScreen {
    get routeName() {
        return uid;
    }

    get reducer() {
        return reducer;
    }

    componentDidMount() {
        super.componentDidMount();
    }

    render() {
        return <EditSectionScreen {...this.props} />;
    }
}

const mapStateToProps = state => {
    return {
        localState: state.screens[reducer.key] ? state.screens[reducer.key] : INITIAL_STATE,
        userId: state.session.userId
    };
};

const mapDispatchToProps = dispatch => {
    return {
        
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation(uid)(AddSectionScreen));